export enum KycStatus {
    Default = 0,
    Verified = 1,
    NonVerified = 2,
}

export enum LaunchSource {
    Gyml = 'sports_gyml',
    LiveCasino = 'sports_livecasino',
}

export class LiveCasinoGameTrackingModel {
    id?: string;
    gameName: string;
    gameType: string;
    gamePosition: number;
    gridPosition: string;
    gameDisplayName: string;
    gameCategoryType: string;
    gameSubCategoryType: string;
}

export enum LiveCasinoTrackingConstants {
    Game_Section = 'sports/live/casino',
    Game_Container_Location = 'Live',
    Game_Category_Type = 'LIVECASINO',
    Game_Category_Sub_Type = 'sports_Live_nav',
    Game_List = 'Casino Games',
}
